const hqIdRegex = /\/hq\/([a-f0-9-]+)\//;

/**
 * Helper to extract hq id from a route.
 * Usually this is done through the react-router useParams hook
 * but in cases when parents are trying to evaluate child paths this doesn't work.
 */
export const getHqId = (pathName: string) => {
  const match = pathName.match(hqIdRegex);
  return match?.[1];
};
